import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import QueueAnim from 'rc-queue-anim'
import { Button } from './Button'
import Icon from './Icon'
import zIndex from '../../utils/zIndexScale'

const Layer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${zIndex.modal};
  background: rgba(0, 0, 0, 0.5);
`

const Wrapper = styled.div`
  min-width: 320px;
  max-width: 450px;
  padding: 30px;
  box-sizing: border-box;
  background: ${({ theme }) => theme.popupBg};
  box-shadow: ${({ theme }) => theme.boxShadow};
  position: fixed;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  @media (max-width: 768px) {
    width: 100%;
    min-width: 300px;
    max-width: 300px;
    padding: 15px;
    top: 20%;
  }
`

const Content = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px 0 20px 0;
  font-size: 16px;
  color: ${props => props.theme.fontColor};
`

const Footer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`

const ConfirmButton = styled(Button)`
  height: 34px;
  line-height: 34px;
`

const CancelButton = styled(Button)`
  background: inherit;
  color: #f0b90b;
  border: 1px solid #f0b90b;
  box-shadow: none;
  height: 34px;
  line-height: 34px;
  margin-right: 25px;
  box-sizing: border-box;
`

const Close = styled.div`
  position: absolute;
  top: 5px;
  right: 8px;
  cursor: pointer;
  color: #848e9c;
  line-height: 20px;
  &:hover {
    color: #f0b90b;
  }
`

class Confirm extends PureComponent {
  static propTypes = {
    okText: PropTypes.string,
    cancelText: PropTypes.string,
    confirm: PropTypes.func,
    cancel: PropTypes.func,
    children: PropTypes.element,
  }

  static defaultProps = {
    okText: '',
    cancelText: '',
    confirm: () => {},
    cancel: () => {},
    children: null,
  }

  componentDidMount() {
    document.body.style.overflow = 'hidden'
    window.document.body.addEventListener('keydown', this._keydown)
  }

  componentWillUnmount() {
    document.body.style.overflow = ''
    window.document.body.removeEventListener('keydown', this._keydown)
  }

  _keydown = ev => {
    const { cancel } = this.props
    if (ev.keyCode === 27) {
      cancel()
    }
  }

  render() {
    const { cancelText, okText, children, confirm, cancel } = this.props
    return (
      <QueueAnim
        animConfig={[
          {
            opacity: [1, 0],
          },
        ]}
      >
        <Layer key="1">
          <QueueAnim leaveReverse={true} delay={100} type={['top', 'bottom']}>
            <Wrapper key="2">
              <Content>{children}</Content>
              <Footer>
                <CancelButton onClick={cancel}>
                  <span>{cancelText}</span>
                </CancelButton>
                <ConfirmButton onClick={confirm}>
                  <span>{okText}</span>
                </ConfirmButton>
              </Footer>
              <Close onClick={cancel}>
                <Icon type="close" size="18" />
              </Close>
            </Wrapper>
          </QueueAnim>
        </Layer>
      </QueueAnim>
    )
  }
}

export default Confirm
